export function isIe() {
  if (typeof window !== 'undefined') {
    const ua = window.navigator.userAgent
    return /MSIE|Trident/.test(ua)
  }
}
